import axios from 'axios'
import { store } from './store'

import { Service } from 'axios-middleware'

export const AND_SUB_SEPARATOR = ',,'
export const OR_SUB_SEPARATOR = '||'
export const AND_SEPARATOR = ','
export const OR_SEPARATOR = '|'
export const LIKE_OPERATOR = 'like'
export const EQ_OPERATOR = 'eq'

const service = axios.create({
  baseURL: process.env.VUE_APP_APIURL
})

const middlewareService = new Service(service)
const onErrorResponse = (error) => {
  let config = error.response.config || {}
  // console.log(error.response.status)
  if (error.response.status === 304) {
    let errorMessage = {
      status_code: error.response.status,
      errors: [{ name: 'resource', messages: [error.statusText] }],
      // include the config in the error so the request can be rerun if needed
      config: error.config
    }
    // console.log(errorMessage)
    return errorMessage
  }
  if (error.response.status === 500) {
    let errorMessage = {
      status_code: error.response.status,
      errors: [{ name: 'resource', messages: ['Server Error'] }],
      // include the config in the error so the request can be rerun if needed
      config: error.config
    }
    // console.log(errorMessage)
    return errorMessage
  }
  // console.log(error.response.headers)
  let data = JSON.parse(error.response.data)
  // console.log(data)
  // include the config in the error so the request can be rerun if needed
  let response = { ...data, config }
  return response
}

middlewareService.register({
  onRequest(config) {
    if (process.env.NODE_ENV !== 'production') {
      const { url, params, method, data } = config
      // console.log({ url, params, method, data })
    }
    return config
  },
  onResponse(response) {
    if (store.getters['app/offline']) {
      store.dispatch('app/setOffline', false)
    }
    return response
  },
  onResponseError(error) {
    return new Promise((resolve, reject) => {
      if (error.response) {
        let message = onErrorResponse(error)
        return reject(message)
      } else {
        // Something happened in setting up the request that triggered an Error
        // build an error structure that the system expects
        let status_code = error.message === 'Network Error' ? 503 : 500
        if (status_code === 503) {
          store.dispatch('app/setOffline', true)
        }
        let errorMessage = {
          status_code,
          errors: [{ name: 'resource', messages: [error.message] }],
          // include the config in the error so the request can be rerun if needed
          config: error.config
        }
        // console.log(errorMessage)
        reject(errorMessage)
      }
    })
  }
})

export { service as axios, middlewareService as axiosMiddlewareService }
